/*
Version 0.115

Made by: Finally // Aleks Schakel // www.finally.nl // aleks@finally.nl
Copyright 2016 - 2018.

!Changelog

2021
	20-01-2021
	- [BORN] This class is born. Hooray!

!Usage
	specific_mobilemenu.onready();

	
!Wishlist

	none
	
*/
  
var specific_measuredocument = {};

(function(){
	 
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	// CONSTRUCTOR ********************************************************************
	
	this.onready = function() {

		/*
		Submit
		*/
		$('.js-measuredocument-send').on('click',function() {

			/*
			Check if signatures are filled in
			*/
			var _signature_1_active = $('.js-measuredocument-signature-box[data-signature-from="buyer"]').hasClass('active');
			var _signature_2_active = $('.js-measuredocument-signature-box[data-signature-from="meter"]').hasClass('active');

			if(
				_signature_1_active == true &&
				_signature_2_active == true
			) {
			
				var _measuredocument_id 	= $('.js-measuredocument-id').val();

				// /*
				// XHR: Exact.php first
				// XHR: Exact.php first
				// XHR: Exact.php first
				// XHR: Exact.php first
				// */

				// /*
				// Show: Modal
				// */
				// modal.open('loading');

				// $.ajax({
				// 	url: globalUrl + '/exact.php',
				// 	type: "POST",
				// 	data: {
				// 		'what':'inmeetdocument'
				// 	},
				// 	headers: { 
				// 		'go-load':1
				// 	}
				// })
				// .done(function(data) {

				// 	setTimeout(function() {

				// 		modal.close();

				popup.open(1,1,'project-werktekening-pdf/' + _measuredocument_id);

				// 	},1000);

				// })
				// .always(function() {
				// });

			} else {
				alert('Niet alle handtekeningen zijn ingvuld. Probeer nogmaals.');
			}

		});

		/*
		Open signature
		*/
		$('.js-measuredocument-signature-box').on('click',function() {
			var _type 				= $(this).data('signature-type');
			var _from 				= $(this).data('signature-from');
			var _measuredocument_id 	= $('.js-measuredocument-id').val();

			popup.open(1,1,'signature/' + _type + '/' + _from + '/' + _measuredocument_id);
		});
		
	};

	// METHODS  *****************************************************************
	// METHODS *****************************************************************
	// METHODS ******************************************************************
	// METHODS ******************************************************************
	
	// none
		
}).apply(specific_measuredocument); 